exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".userlist-component .user{display:block;padding:10px 15px;border-bottom:1px solid #e5eaeb}.userlist-component .user h4{color:#333}.userlist-component .user .user-avatar{margin-right:15px;border-radius:50%;width:50px;height:50px;border:1px solid #e5eaeb}.userlist-component .user .text-gray{height:19px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/UserList.scss
// module id = 675
// module chunks = 0